<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <section
      height="200px"
      class="
        w-full
        py-12
        flex
        justify-center
        items-center
        flex-col
        lg:flex-row
        border-none
      "
    >
      <v-text-field
        label="Nombre del alumno a buscar"
        outlined
        :rules="[
          (v) => !!v || 'Nombre de alumno requerido.',
          (v) => v.length > 2 || 'Mínimo 3 caracteres.',
        ]"
        required
        v-model="nombre"
        class="mx-4"
      ></v-text-field>

      <v-text-field
        label="Apellidos del alumno a buscar"
        outlined
        :rules="[
          (v) => !!v || 'Apellidos de alumno requerido.',
          (v) => v.length > 2 || 'Mínimo 3 caracteres.',
        ]"
        required
        v-model="apellidos"
        class="mx-4"
      ></v-text-field>
    </section>
    <v-flex justify-between>
      <v-btn text @click="back">Volver</v-btn>
      <v-btn
        color="primary"
        :disabled="!valid"
        :loading="loading"
        @click="search"
        >Buscar</v-btn
      >
    </v-flex>
    <v-snackbar v-model="snackbar" multi-line centered>
      No se ha encontrado alumno con esos datos.
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import store from "@/store";

export default {
  name: "StepOne",

  props: {
    step: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      snackbar: false,
      valid: false,
      nombre: "",
      apellidos: "",
    };
  },

  methods: {
    back() {
      store.state.validPassword = false;

      this.$router.push({ name: "Login" });
    },
    search() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        window.CmsApi.hook(this.$root.hookEndPoint, {
          action: "searchAlumno",
          data: JSON.stringify({
            nombre: this.nombre,
            apellidos: this.apellidos,
            centro: this.$root.centro.num,
          }),
        })
          .then((response) => {
            if (response.data.datos !== null) {
              this.$root.posiblesAlumnos = response.data.datos.registros;

              this.$emit("change-step", this.step + 1);
            } else {
              this.snackbar = true;
            }
          })
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>
